import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Button, ButtonProps } from './Button';
import { SubmitButton } from './SubmitButton';

const useStyles = createUseStyles(() => ({
  buttonContainer: {
    textAlign: 'center',
  },
}));

interface Props {
  submitButton?: boolean;
  text?: string;
  children?: React.ReactNode;
}

export const CenteredButton = ({
  submitButton,
  text,
  children,
  ...props
}: Props & ButtonProps) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const Component = submitButton ? SubmitButton : Button;

  return (
    <div className={classes.buttonContainer}>
      {children}
      <Component {...props} text={text} />
    </div>
  );
};
